<div class="appointments">

  <div class="section-title">
    <!--
    <h3> Rendez vous ({{appointments == null ? 0 : appointments!.length}})</h3>
    <button *ngIf="(appointments == undefined || appointments.length === 0 )"
      class="cta-button"  mat-button (click)="openAppointmentDialog('', undefined);$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button> -->

    @if (enableNew) {
      <button mat-button class="cta-button-buy"  mat-button (click)="openAppointmentDialog(0, false);$event.stopPropagation()">
        Nouvelle<mat-icon>add</mat-icon>
      </button>
    }
  </div>

  @if (!(appointments !== null  && appointments !== undefined && appointments.length > 0)) {
    <h6>
      Aucun rendez vous en cours
    </h6>
  }

  @if (!(appointments == null || appointments == undefined || appointments.length === 0 )) {
    <div class="appointment-list">
      @for (appointment of appointments; track appointment; let i = $index) {
        <div class="appointment">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b> -->
            @if (objectSource===ObjectSource.DEALER) {
              <h4> {{appointment.carMake}} {{appointment.carModel}} {{appointment.carVersion}}, {{appointment.carYear}}</h4>
            }
            <h5 class="summary-details"><mat-icon>forum</mat-icon> N° {{appointment.id}} - {{appointment.locationMode}} </h5>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Client: <b>{{appointment.customerFirstName }} {{appointment.customerLastName }} - {{appointment.customerBusinessName}}</b></h6>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Vendeur: <b>{{appointment.providerName}} - {{appointment.providerBusinessName}}</b></h6>
            <h6 class="summary-details"><mat-icon>call</mat-icon><b>{{appointment.needCallback}}</b></h6>
          </div>
          <div class="content">
            <h4> <b>{{dateFormat(appointment.appointmentDate)}}</b></h4>
            <h6> @for (item of appointment.services; track item) {
              <b> {{item}} </b>
            }</h6>
            <h5 class="status"> <b>{{appointment.status}}</b></h5>
            <h6> Détails: {{appointment.details}}</h6>
            <h6> Date report demandée: {{dateFormat(appointment.rescheduleDate)}}</h6>
            <!--
            <h6> Date création: {{dateFormat(appointment.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(appointment.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              @if ((appointment.status === AppointmentStatus.PROPOSED)) {
                <button
                  class="simple-button"  mat-button (click)="openAppointmentDialog(appointment.id, false);$event.stopPropagation()">
                  Editer <mat-icon>edit</mat-icon>
                </button>
              }
              @if ((appointment.status === AppointmentStatus.PROPOSED || appointment.status === AppointmentStatus.SCHEDULED)) {
                <button
                  class="simple-button"  mat-button (click)="openAppointmentDialog(appointment.id, true);$event.stopPropagation()">
                  Reprg <mat-icon>calendar</mat-icon>
                </button>
              }
              @if ((appointment.status === AppointmentStatus.PROPOSED || appointment.status === AppointmentStatus.BUYER_RESC)) {
                <button
                  class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.SCHEDULED);$event.stopPropagation()">
                  Accepter <mat-icon>accept</mat-icon>
                </button>
              }
              @if ((appointment.status !== AppointmentStatus.CANCELLED)) {
                <button
                  class="simple-button"  mat-button (click)="updateAppointmentStatus(appointment.id, AppointmentStatus.CANCELLED);$event.stopPropagation()">
                  Annuler <mat-icon>cancel</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>